import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { Button, ButtonCircularProgress } from '../button/button.js';

function IconButton({ variant = "primary", color = "default", size = "medium", disabled = false, loading = false, Icon, ...rest }) {
    const _disabled = disabled || loading;
    return (jsx(Button, { variant: variant, color: color, disabled: _disabled, size: size, shape: "circle", ...rest, children: !loading ? (jsx(IconWrapper, { "$size": size, children: jsx(Icon, {}) })) : (jsx(ButtonCircularProgress, { "$variant": variant, "$color": color, size: getIconSize({ $size: size }), "$disabled": _disabled })) }));
}
const IconWrapper = styled.div `
  svg {
    display: block;
    width: ${({ $size }) => getIconSize({ $size })};
    height: ${({ $size }) => getIconSize({ $size })};
  }
`;
function getIconSize({ $size }) {
    switch ($size) {
        case "small":
            return "1.125rem";
        case "medium":
        default: {
            return "1.25rem";
        }
    }
}

export { IconButton };
